import { render, staticRenderFns } from "./TodoAddNew.vue?vue&type=template&id=15317fb8"
import script from "./TodoAddNew.vue?vue&type=script&lang=js"
export * from "./TodoAddNew.vue?vue&type=script&lang=js"
import style0 from "./TodoAddNew.vue?vue&type=style&index=0&id=15317fb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports